var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mt-5"},[_c('v-progress-circular',{attrs:{"size":_vm.size,"color":_vm.color,"indeterminate":""}}),_c('p',[_vm._v(_vm._s(_vm.type)+" "+_vm._s(_vm.text)+"...")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }